import { useEffect, useRef } from 'react';
import noop from 'lodash-es/noop';

/**
 *
 * @param {Boolean} isPollingStarted
 * @param {Function} callback
 * @param {number} delay
 * Taken from https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */

let initialCall = true;

const useInterval = (isPollingStarted, callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null && isPollingStarted) {
      if (initialCall) {
        initialCall = false;
        return tick();
      }
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    initialCall = true;
    return noop;
  }, [delay, isPollingStarted]);
};

export default useInterval;
